<template>
    <Multiselect data-slot="control" v-model="modelValue" :options :noOptionsText="resolvedNoOptionsText" :noResultsText="resolvedNoResultsText" :placeholder="resolvedPlaceholder" :hideSelected :searchable :canClear="canClear" ref="multiselect" :aria-invalid="hasError" :aria-describedby="errorId" :class="[`multiselect-${size}`, `multiselect-${variant}`]">
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </Multiselect>
</template>

<script setup>
import { computed } from 'vue'
import Multiselect from '@vueform/multiselect'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const modelValue = defineModel('modelValue', {
    type: [Array, Object, String, Number],
    default: '',
})

const props = defineProps({
    placeholder: {
        type: String,
        default: '',
    },
    noOptionsText: {
        type: String,
        default: '',
    },
    options: {
        type: [Array, Function],
        default: () => [],
    },
    noResultsText: {
        type: String,
        default: '',
    },
    searchable: {
        type: Boolean,
        default: true,
    },
    canClear: {
        type: Boolean,
        default: false,
    },
    hideSelected: {
        type: Boolean,
        default: false,
    },
    hasError: {
        type: Boolean,
        default: false,
    },
    errorId: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: 'md',
        validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
    variant: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'form'].includes(v),
    },
})

const resolvedPlaceholder = computed(() => props.placeholder || t('Type to search'))
const resolvedNoOptionsText = computed(() => props.noOptionsText || t('No options found'))
const resolvedNoResultsText = computed(() => props.noResultsText || t('No results found'))

const multiselect = ref(null)

defineExpose({
    open: () => {
        if (multiselect.value) {
            multiselect.value.activate()
        }
    },
    close: () => {
        if (multiselect.value) {
            multiselect.value.close()
        }
    },
})
</script>
